import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { TemplatesPage } from "@src/components/modules/templates";
import { TemplatesNavigation } from "@src/components/modules/templates/navigation";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Templates`} navigation={<TemplatesNavigation />}>
    <TemplatesPage />
  </MainLayout>
);

export const Route = createFileRoute("/templates/")({
  component: Page,
});
